/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { CircularProgress, Tooltip, useMediaQuery } from '@material-ui/core';
import { useMemo, useState } from 'react';
import './calendar.css';
import CalendarEventModal from './CalendarEventModal';
import EventsDrawer from './EventsDrawer';

const MonthlyCalendar = ({ week, events, loading, printView, refresh, setRefresh }) => {
	const [filterEvent, setFilterEvent] = useState([]);
	const [currentday, setcurrentday] = useState(null);
	const [eventsDrawerOpen, setEventsDrawerOpen] = useState(false);
	const [eventModalOpen, setEventModalOpen] = useState(false);
	const [currentSelectedEvent, setCurrentSelectedEvent] = useState(null);
	const isCompact = useMediaQuery('(max-width:600px)');

	const handleOpenEventsDrawer = (event, day) => {
		setcurrentday(day);
		setFilterEvent(
			events.filter(
				(event) =>
					new Date(`${event.datetime}`).getDate() === day.toDate().getDate() &&
					new Date(`${event.datetime}`).getMonth() === day.toDate().getMonth()
			)
		);
		setEventsDrawerOpen(true);
	};

	const handleCloseEventsDrawer = () => {
		setEventsDrawerOpen(false);
	};

	return (
		<>
			{!printView ? (
				<>
					<EventsDrawer
						currentDay={currentday}
						filterEvent={filterEvent}
						fixed={isCompact}
						onClose={handleCloseEventsDrawer}
						open={eventsDrawerOpen}
						refresh={refresh}
						setRefresh={setRefresh}
					/>
					<CalendarEventModal
						event={currentSelectedEvent}
						open={eventModalOpen}
						refresh={refresh}
						setOpen={setEventModalOpen}
						setRefresh={setRefresh}
					/>
				</>
			) : null}
			<div className="">
				<div className="flex flex-col ">
					<div
						className="grid grid-cols-7  border-grey-border  font-bold text-gray-500"
						style={{ justifyItems: 'center' }}
					>
						<div className="flex justify-center items-center w-full border-l-1 border-grey-border h-40 md:h-52">
							<div className="md:hidden">M</div>
							<div className="hidden md:block">Mon</div>
						</div>
						<div className="flex justify-center items-center w-full border-l-1 border-grey-border h-40 md:h-52">
							<div className="md:hidden">T</div>
							<div className="hidden md:block">Tue</div>
						</div>
						<div className="flex justify-center items-center w-full border-l-1 border-grey-border h-40 md:h-52">
							<div className="md:hidden">W</div>
							<div className="hidden md:block">Wed</div>
						</div>
						<div className="flex justify-center items-center w-full border-l-1 border-grey-border h-40 md:h-52">
							<div className="md:hidden">Th</div>
							<div className="hidden md:block">Thu</div>
						</div>
						<div className="flex justify-center items-center w-full border-l-1 border-grey-border h-40 md:h-52">
							<div className="md:hidden">F</div>
							<div className="hidden md:block">Fri</div>
						</div>
						<div className="flex justify-center items-center w-full border-l-1 border-grey-border h-40 md:h-52">
							<div className="md:hidden">Sa</div>
							<div className="hidden md:block">Sat</div>
						</div>
						<div className="flex justify-center items-center w-full border-l-1 border-r-1 border-grey-border h-40 md:h-52">
							<div className="md:hidden">Su</div>
							<div className="hidden md:block">Sun</div>
						</div>
					</div>
					{loading ? (
						<div className="loading-spinner">
							<CircularProgress size={35} />
						</div>
					) : (
						<div className="grid grid-cols-7">
							{week.map((day, index) => {
								const currentDayEvents = events.filter(
									(event) =>
										new Date(`${event.datetime}`).getDate() === day.toDate().getDate() &&
										new Date(`${event.datetime}`).getMonth() === day.toDate().getMonth()
								);
								const disabled = (index < 8 && day.date() > 20) || (index > 27 && day.date() < 10);
								const isToday =
									new Date().getDate() === day.toDate().getDate() && new Date().getMonth() === day.toDate().getMonth();
								return (
									<div
										className={`${
											isCompact ? 'cursor-pointer hover:shadow-md' : ''
										} px-2 sm:px-8 sm:py-20 pt-20 monthly-day-block h-60 sm:h-92 md:min-h-136 flex flex-col relative justify-between ${
											index > 27 ? 'monthly-day-block-btm-border' : ''
										} ${[6, 13, 20, 27, 34].includes(index) ? 'monthly-day-block-right-border' : ''}
                                ${disabled ? 'monthly-day-block-disabled' : ''}
                                `}
										key={`${day.toISOString()}-${index}`}
										onClick={() => {
											return isCompact ? handleOpenEventsDrawer(null, day) : null;
										}}
									>
										<div
											className={`ml-auto ${
												!isCompact ? 'cursor-pointer sm:p-4 md:p-8 rounded-full hover:shadow ' : ''
											} text-pd-xs absolute top-0 font-bold md:text-pd-sm  ${
												isToday && !printView
													? ' border rounded-full w-20 h-20 md:h-32 md:w-32 flex justify-center items-center bg-pd-blue-light right-0 text-white'
													: 'right-2'
											}`}
											onClick={() => {
												return !isCompact ? handleOpenEventsDrawer(null, day) : null;
											}}
										>
											{day.date().toLocaleString('en-US', {
												minimumIntegerDigits: 2,
												useGrouping: false,
											})}
										</div>
										{!disabled && !printView ? (
											<>
												<div className=" sm:h-full flex flex-wrap sm:flex-nowrap md:mt-20 sm:flex-col gap-2 xs:gap-4">
													{isCompact
														? currentDayEvents.map((event, index) => {
																return (
																	<MonthlyEventChip
																		event={event}
																		isCompact={isCompact}
																		key={`${event.id}-${index}`}
																		refresh={refresh}
																		setRefresh={setRefresh}
																	/>
																);
															})
														: currentDayEvents
																.slice(0, 2)
																.map((event) => (
																	<MonthlyEventChip
																		event={event}
																		eventModalOpen={eventModalOpen}
																		isCompact={isCompact}
																		key={`${event.id}-${index}`}
																		refresh={refresh}
																		setCurrentSelectedEvent={setCurrentSelectedEvent}
																		setEventModalOpen={setEventModalOpen}
																		setRefresh={setRefresh}
																	/>
																))}
												</div>
												<div>
													{currentDayEvents.length > 2 ? (
														<div className="view-all-monthly" onClick={(e) => handleOpenEventsDrawer(e, day)}>
															<span className="hidden sm:block mt-6">{`+${currentDayEvents?.length - 2} more`}</span>
														</div>
													) : (
														''
													)}
												</div>
											</>
										) : null}
										{!disabled && printView ? (
											<div className="-mt-10">
												{currentDayEvents.map((event) => {
													const isCustomEvent = event?.type === '39';
													return (
														<p
															className="py-2"
															key={`${event.id}-${index}`}
															style={{
																fontSize: currentDayEvents.length > 4 ? '.65rem' : '1rem',
															}}
														>
															{isCustomEvent ? event?.custom_type : event?.event_type?.type}
														</p>
													);
												})}
											</div>
										) : null}
									</div>
								);
							})}
						</div>
					)}
				</div>
			</div>
		</>
	);
};

const MonthlyEventChip = ({ event, setEventModalOpen = () => {}, setCurrentSelectedEvent = () => {} }) => {
	const randomNumber = useMemo(() => {
		return Math.ceil(Math.random() * 6);
	}, [event.id]);

	const handleOpenEventModal = () => {
		setEventModalOpen(true);
		setCurrentSelectedEvent(event);
	};

	const isCustomEvent = event?.type === '39';

	return (
		<Tooltip
			title={
				event?.event_type?.type === 'Special Event'
					? event?.description
					: isCustomEvent
						? event?.custom_type
						: event?.event_type?.type
			}
		>
			<div
				className={`md:mx-auto event-random-${randomNumber} event-random-monthly rounded-full h-10 sm:py-1 sm:px-4 max-w-10 sm:h-20 sm:max-w-full sm:max-h-full justify-between sm:flex items-center  md:h-auto cursor-pointer hover:shadow`}
				onClick={handleOpenEventModal}
			>
				<span className="text-pd-xs truncate hidden sm:block">
					{isCustomEvent ? event?.custom_type : event?.event_type?.type}
				</span>
				<img
					alt={event?.event_type?.type}
					className="hidden md:block max-h-16 sm:max-h-full sm:max-w-full w-16 sm:w-28 sm:h-28"
					src={event?.event_type?.icon_url}
					style={{}}
				/>
			</div>
		</Tooltip>
	);
};

export default MonthlyCalendar;
